const ReviewType = {
	All: {
		key: 'All',
		text: 'All',
		doShowIfZero: true,
		dontFilter: true,
	},
	Rated0to2: {
		key: 'Rated0to2',
		text: 'Rated 0-2',
		lowRating: 0,
		highRating: 2,
		showAsPanel: true,
	},
	Rated3to5: {
		key: 'Rated3to5',
		text: 'Rated 3-5',
		lowRating: 3,
		highRating: 5,
		showAsPanel: true,
	},
	Rated6to8: {
		key: 'Rated6to8',
		text: 'Rated 6-8',
		lowRating: 6,
		highRating: 8,
		showAsPanel: true,
	},
	Rated9to10: {
		key: 'Rated9to10',
		text: 'Rated 9-10',
		lowRating: 9,
		highRating: 10,
		showAsPanel: true,
	},
};

export default ReviewType;
